import { Helmet } from 'react-helmet-async';
// @mui
import { Grid, Container, Typography, Stack, useMediaQuery } from '@mui/material';
// components

// sections
import { AppWidgetSummary } from '../sections/@dashboard/app';
import { eventList, glb_sv } from 'src/utils';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ChooseCabinetModal from 'src/components/modal/ChooseCabinetModal';
import crypt from 'src/utils/service/crypt';
import { useTheme } from '@mui/material/styles';
import { truncate } from 'lodash';

export default function DashboardAppPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const user = glb_sv.userInfo;
    const [tableData, setTableData] = useState([]);
    const [valueCabinet, setValueCabinet] = useState(null);
    const [cancelChooseCabinet, setCancelChooseCabinet] = useState(true);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const userData = sessionStorage.getItem('proc_data');
    const menu = sessionStorage.getItem('menu');
    if (!userData || !menu) {
        navigate('/login');
    }

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        const menu = sessionStorage.getItem('menu');
        if (!userData || !menu) {
            navigate('/login');
        }
        if (userData && menu) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                glb_sv.userInfo = data;
                glb_sv.menu = JSON.parse(crypt.deCode(menu));
                glb_sv.sessionInfo.comp_id = data.o_3;
                glb_sv.sessionInfo.branch_id = data.o_4;
                glb_sv.sessionInfo.user_id = data.id;
            } catch (error) {}
        }
    }, []);

    // useEffect(() => {
    //     const docEl = document.documentElement;
    //     const isCurrentlyFullScreen =
    //         document.fullscreenElement ||
    //         document.mozFullScreenElement ||
    //         document.webkitFullscreenElement ||
    //         document.msFullscreenElement;
    //     const requestFullScreen =
    //         docEl.requestFullscreen ||
    //         docEl.mozRequestFullScreen ||
    //         docEl.webkitRequestFullscreen ||
    //         docEl.msRequestFullscreen;
    //     if (requestFullScreen && fullScreen && !isCurrentlyFullScreen) {
    //         glb_sv.commonEvent.next({ type: eventList.ZOOM_SCREEN, data: true });
    //     }
    // }, []);
    // useEffect(() => {
    //     if (
    //         !document.fullscreenElement &&
    //         !document.mozFullScreenElement &&
    //         !document.webkitFullscreenElement &&
    //         !document.msFullscreenElement && fullScreen
    //     ) {
    //         glb_sv.commonEvent.next({ type: eventList.ZOOM_SCREEN, data: true });
    //     }
    // }, [])

    useEffect(() => {
        glb_sv.menu.length > 0 && setTableData(glb_sv.menu);
    }, [glb_sv.menu]);

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        if (userData) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                user.current = data;
            } catch (error) {}
        }
        if(glb_sv.menu.length == 0){
            setVisible(false);
            return
        }
        if ((user.current?.group_user !== '0' && !visible)) {
            const cabinetLocal = glb_sv.getLocalStorageCabinet('cabinet');
            // const cabinetSession = sessionStorage.getItem('cabinet');
            if (!cabinetLocal) setVisible(true);
            if (cabinetLocal) {
                setValueCabinet(cabinetLocal);
            } else if (!cabinetLocal) {
                setVisible(true);
                // setValueCabinet(JSON.parse(cabinetSession));
            } else if (cancelChooseCabinet === false) {
                setVisible(true);
            }
        }
        // if (tableData[0]?.group_user === '3') {
        // const cabinet = sessionStorage.getItem('cabinet');
        // if (!cabinet) {
        //     setVisible(true);
        // }
        // }
    }, [visible, glb_sv.menu]);
    return (
        <>
            {userData && menu ? (
                <>
                    <Helmet>
                        <title> {t('home')} </title>
                    </Helmet>
                    <ChooseCabinetModal
                        visible={visible}
                        setVisible={setVisible}
                        cancelChooseCabinet={cancelChooseCabinet}
                        setValueCabinet={setValueCabinet}
                        setCancelChooseCabinet={setCancelChooseCabinet}
                    />
                    {/* {tableData[0]?.group_user === '3' && <ChooseCabinetModal visible={visible} setVisible={setVisible} />} */}
                    <Container maxWidth="xl">
                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            mb={1}
                            flexWrap={'wrap'}
                        >
                            <Typography variant="h5" sx={{ mb: 3 }}>
                                {t('hello')}, {user?.user_nm}
                            </Typography>
                            {valueCabinet && (
                                <Typography>
                                    {' '}
                                    {t('text_cabinet')}
                                    {` ${valueCabinet.cabinet_nm} `}
                                </Typography>
                            )}
                        </Stack>

                        <Grid container spacing={3}>
                            {tableData[0]?.length > 0 &&
                                tableData[0]?.map((item, i) => {
                                    if (item?.search_permission === '1')
                                        return (
                                            <Grid item xs={12} sm={6} md={3} key={i}>
                                                <AppWidgetSummary
                                                    onClick={() => navigate(item?.navigate + item?.id)}
                                                    title={t(item?.screens_key)}
                                                    to={item?.navigate + item?.id}
                                                    icon={item?.icons}
                                                />
                                            </Grid>
                                        );
                                })}
                        </Grid>

                        {/* <Grid container spacing={3}>
                    {tableData.length > 0 &&
                        tableData.map((item, i) => {
                            if (item?.permiss_screen?.search === '1')
                                return (
                                    <Grid item xs={12} sm={6} md={3} key={i}>
                                        <AppWidgetSummary
                                            onClick={() => navigate(item.navigate + item.id)}
                                            title={t(item.screens_key)}
                                            to={item.navigate + item.id}
                                            icon={item.icons}
                                        />
                                    </Grid>
                                );
                        })}
                </Grid> */}
                    </Container>
                </>
            ) : (
                <></>
            )}
        </>
    );
}
